import React, { ReactNode, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

const UserAuthGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const auth = useAuth();

  const getQueryParams = (param: string) => {
    const params = new URLSearchParams(window.location.search);
    return params.get(param);
  };

  const userId = getQueryParams('userId');
  const notification = getQueryParams('fromNotification');
  const loggedInUserId = auth.user?.profile?.sub;

  useEffect(() => {
    if (userId != null && loggedInUserId != null && userId !== loggedInUserId) {
      window.location.href = notification ? `${window.REACT_APP_API_BASE_URI}/wrong-notification` : `${window.REACT_APP_API_BASE_URI}/wrong-user`;
    }
  }, [loggedInUserId, userId, notification]);

  return <>{children}</>;
};

export default UserAuthGuard;
